function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { Image, Link } from "@labs/schema";
import clsx from "clsx";
import React from "react";
import { FadeUp } from "../Molecules/FadeUp";
export function GridLogos(param) {
    var title = param.title, smallTitle = param.smallTitle, subText = param.subText, logos = param.logos;
    return /*#__PURE__*/ React.createElement("div", {
        className: "container-page"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-content"
    }, title ? /*#__PURE__*/ React.createElement(FadeUp, {
        yGap: 50
    }, /*#__PURE__*/ React.createElement("h3", {
        className: clsx("container-content-wrapper text-turquoise-500 w-auto block text-center", {
            "text-black text-sm font-lexend mb-3": !!smallTitle
        })
    }, title)) : null, /*#__PURE__*/ React.createElement(FadeUp, {
        yGap: 50
    }, /*#__PURE__*/ React.createElement("section", {
        className: clsx("container-content-wrapper group mb-20 grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-y-4 md:gap-6 content-center justify-items-center", {
            "lg:mb-28": !subText,
            "mt-12": !subText && !smallTitle,
            "lg:mb-10": subText,
            "mt-3": !!smallTitle
        })
    }, logos.map(function(item, index) {
        return /*#__PURE__*/ React.createElement(GridItem, _extends({}, item, {
            key: index
        }));
    }))), subText ? /*#__PURE__*/ React.createElement("p", {
        className: "mx-auto text-center text-xs"
    }, subText) : null));
}
export function GridItem(param) {
    var link = param.link, image = param.image, label = param.label;
    return /*#__PURE__*/ React.createElement("div", {
        className: "grid content-center grid-cols-1"
    }, link ? /*#__PURE__*/ React.createElement(Link, {
        href: link
    }, /*#__PURE__*/ React.createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ React.createElement(Image, _extends({}, image, {
        alt: label,
        className: "relative max-h-full"
    })))) : /*#__PURE__*/ React.createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ React.createElement(Image, _extends({}, image, {
        alt: label,
        className: "relative max-h-full"
    }))));
}
